import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import PrivateRoute from 'components/routes/Private'
import AllGlobalRolesRoute from 'components/routes/AllGlobalRoles'
import AnyGlobalRolesRoute from 'components/routes/AnyGlobalRoles'
import { lifecycle, compose } from 'recompose'

import {
  GLOBAL_ROLES,
  ROUTE_ROLES,
} from 'containers/Role/constants'

// Product Creation
import ProductCreate from 'containers/ProductCreatePage/index'
import ProductSearch from 'containers/ProductSearchPage/index'
import ProductView from 'containers/Product/View/index'

const ProductIdRoutes = props => {
  return (
    <Switch>
      <AnyGlobalRolesRoute
        component={ProductView}
        exact
        path='/product/:id/view'
        roles={[
          GLOBAL_ROLES.ADMIN_ACCESS,
          ROUTE_ROLES.DATA_MANAGER
        ]}
      />
    </Switch>
  )
}

const ProductRoutes = props => {
  return (
    <Switch>
      <AnyGlobalRolesRoute exact path='/product/list' roles={[GLOBAL_ROLES.ADMIN_ACCESS, ROUTE_ROLES.DATA_MANAGER]} component={ProductSearch}/>
      <AllGlobalRolesRoute exact path='/product/search' roles={[GLOBAL_ROLES.ADMIN_ACCESS]} component={ProductSearch}/>
      <PrivateRoute path='/product/:id' component={ProductIdRoutes}/>
    </Switch>
  )
}

export default ProductRoutes
